package com.exura.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import org.koin.core.context.GlobalContext.get

@Composable
inline fun <reified T : Any> injectAndRemember(key: Any = Unit): T = remember(key) { get().get<T>() }
